// Profile Settings copy. English source strings are the fallback keys.
const es = {
  "Settings": "Configuración",
  "Close": "Cerrar",
  "Personal Settings": "Configuración personal",
  "Personal details": "Datos personales",
  "Update your name and contact information": "Actualiza tu nombre e información de contacto",
  "Password & Security": "Contraseña y seguridad",
  "Manage your password and security settings": "Administra tu contraseña y opciones de seguridad",
  "Notifications": "Notificaciones",
  "Configure how you receive notifications": "Configura cómo recibes las notificaciones",
  "Account Settings": "Configuración de la cuenta",
  "Preferences": "Preferencias",
  "Language, timezone, and display settings": "Idioma, zona horaria y visualización",
  "Integrations": "Integraciones",
  "Connect external tools and services": "Conecta herramientas y servicios externos",
  "Organization": "Organización",
  "Organization Settings": "Configuración de la organización",
  "Manage organization name and details": "Administra el nombre y los datos de la organización",
  "Enterprise Addons": "Complementos empresariales",
  "Addons": "Complementos",
  "Enable enterprise integrations and import tools": "Habilita integraciones empresariales y herramientas de importación",
  "Profile updated successfully!": "¡Perfil actualizado correctamente!",
  "Please enter your current password": "Ingresa tu contraseña actual",
  "Please enter a new password": "Ingresa una contraseña nueva",
  "Password must be at least 6 characters": "La contraseña debe tener al menos 6 caracteres",
  "Passwords do not match": "Las contraseñas no coinciden",
  "Password changed successfully!": "¡Contraseña cambiada correctamente!",
  "Password change is not available": "El cambio de contraseña no está disponible",
  "Failed to save changes": "No se pudieron guardar los cambios",
  "Failed to update profile": "No se pudo actualizar el perfil",
  "Failed to change password": "No se pudo cambiar la contraseña",
  "Current password is incorrect": "La contraseña actual es incorrecta",
  "Manage your personal information": "Administra tu información personal",
  "Full Name": "Nombre completo",
  "John Doe": "Juan Pérez",
  "Email Address": "Correo electrónico",
  "This email is used for login and notifications": "Este correo se usa para iniciar sesión y recibir notificaciones",
  "Phone Number (Optional)": "Teléfono (opcional)",
  "Manage your password and security preferences": "Administra tu contraseña y preferencias de seguridad",
  "Current Password": "Contraseña actual",
  "Enter current password": "Ingresa tu contraseña actual",
  "New Password": "Nueva contraseña",
  "Enter new password": "Ingresa la nueva contraseña",
  "Use at least 8 characters with a mix of letters, numbers, and symbols": "Usa al menos 8 caracteres que combinen letras, números y símbolos",
  "Confirm New Password": "Confirmar nueva contraseña",
  "Confirm new password": "Confirma la nueva contraseña",
  "Email Notifications": "Notificaciones por correo",
  "Receive updates via email": "Recibe actualizaciones por correo electrónico",
  "Test Failure Alerts": "Alertas de pruebas fallidas",
  "Get notified when tests fail": "Recibe avisos cuando fallen las pruebas",
  "Weekly Reports": "Informes semanales",
  "Receive weekly summary reports": "Recibe un resumen semanal",
  "Customize your experience": "Personaliza tu experiencia",
  "Language": "Idioma",
  "English": "Inglés",
  "Spanish (Español)": "Español",
  "Language changed to Spanish": "Idioma cambiado a español",
  "Language changed to English": "Idioma cambiado a inglés",
  "Dashboard will be displayed in selected language": "El panel se mostrará en el idioma seleccionado",
  "Timezone": "Zona horaria",
  "Date Format": "Formato de fecha",
  "UTC-8 (Pacific Time)": "UTC-8 (hora del Pacífico)",
  "UTC-5 (Eastern Time)": "UTC-5 (hora del Este)",
  "UTC+0 (GMT)": "UTC+0 (GMT)",
  "MM/DD/YYYY": "MM/DD/AAAA",
  "DD/MM/YYYY": "DD/MM/AAAA",
  "YYYY-MM-DD": "AAAA-MM-DD",
  "Connect external tools and services to enhance your workflow": "Conecta herramientas y servicios externos para mejorar tu flujo de trabajo",
  "Manage your organization name and branding": "Administra el nombre y la imagen de tu organización",
  "Organization ID": "ID de la organización",
  "Organization ID copied to clipboard": "ID de la organización copiado al portapapeles",
  "Copied": "Copiado",
  "Copy": "Copiar",
  "Unique identifier for your organization": "Identificador único de tu organización",
  "Organization Name *": "Nombre de la organización *",
  "Enter organization name": "Ingresa el nombre de la organización",
  "Your organization name displayed across the platform": "Nombre de tu organización que se muestra en la plataforma",
  "Business Address (for invoicing)": "Dirección comercial (para facturación)",
  "Address Line 1": "Dirección, línea 1",
  "Street address, building, P.O. box": "Calle, edificio o apartado postal",
  "Address Line 2 (Optional)": "Dirección, línea 2 (opcional)",
  "Apartment, suite, unit, floor": "Apartamento, oficina, unidad o piso",
  "City": "Ciudad",
  "State / Province": "Estado / provincia",
  "Select State": "Selecciona un estado",
  "Select Province": "Selecciona una provincia",
  "Postal / ZIP Code": "Código postal",
  "Postal or ZIP code": "Código postal",
  "Country *": "País *",
  "Select Country": "Selecciona un país",
  "Logo URL (Optional)": "URL del logotipo (opcional)",
  "URL to your organization logo image": "URL de la imagen del logotipo de tu organización",
  "Logo Preview": "Vista previa del logotipo",
  "Organization logo": "Logotipo de la organización",
  "Failed to load logo image": "No se pudo cargar el logotipo",
  "Organization name is required": "El nombre de la organización es obligatorio",
  "Organization settings updated successfully!": "¡Configuración de la organización actualizada correctamente!",
  "Failed to update organization": "No se pudo actualizar la organización",
  "Saving...": "Guardando...",
  "Save Changes": "Guardar cambios",
  "Enable enterprise-level integrations and import tools": "Habilita integraciones empresariales y herramientas de importación",
  "Azure DevOps Import": "Importación de Azure DevOps",
  "Import work items, test plans, test suites, and test cases from Azure DevOps": "Importa elementos de trabajo, planes, suites y casos de prueba desde Azure DevOps",
  "Enabled": "Habilitado",
  "Disable": "Deshabilitar",
  "Setup Instructions": "Instrucciones de configuración",
  "Go to Azure DevOps → User Settings → Personal Access Tokens": "Ve a Azure DevOps → User Settings → Personal Access Tokens",
  "Create a new token with": "Crea un token nuevo con los permisos",
  "and": "y",
  "scopes": "",
  "Copy your organization URL (e.g., https://dev.azure.com/yourorg)": "Copia la URL de tu organización (por ejemplo, https://dev.azure.com/yourorg)",
  "Paste both values below and enable the addon": "Pega ambos valores abajo y habilita el complemento",
  "Organization URL *": "URL de la organización *",
  "Your Azure DevOps organization URL": "URL de tu organización en Azure DevOps",
  "Personal Access Token *": "Token de acceso personal *",
  "Enter your PAT token": "Ingresa tu token PAT",
  "Token is stored securely and never shared": "El token se almacena de forma segura y no se comparte",
  "Connecting...": "Conectando...",
  "Enable Addon": "Habilitar complemento",
  "Connected to Azure DevOps": "Conectado a Azure DevOps",
  "Test Connection": "Probar conexión",
  "Verify your Azure DevOps connection is working": "Verifica que tu conexión con Azure DevOps funcione",
  "Testing...": "Probando...",
  "Import Data": "Importar datos",
  "Go to": "Ve a",
  "to import work items, test plans, and test cases from Azure DevOps. Look for the \"Import from Azure DevOps\" button in the sidebar.": "para importar elementos de trabajo, planes y casos de prueba desde Azure DevOps. Busca el botón \"Importar desde Azure DevOps\" en el menú lateral.",
  "Update Credentials": "Actualizar credenciales",
  "Organization URL": "URL de la organización",
  "New Personal Access Token": "Nuevo token de acceso personal",
  "Enter new PAT token to update": "Ingresa un token PAT nuevo para actualizarlo",
  "Updating...": "Actualizando...",
  "More Addons Coming Soon": "Próximamente, más complementos",
  "Additional enterprise integrations will be available here": "Aquí encontrarás más integraciones empresariales",
  "Please fill in all fields": "Completa todos los campos",
  "Azure DevOps addon enabled successfully!": "¡Complemento de Azure DevOps habilitado correctamente!",
  "Failed to enable addon": "No se pudo habilitar el complemento",
  "Azure DevOps addon disabled": "Complemento de Azure DevOps deshabilitado",
  "Failed to disable addon": "No se pudo deshabilitar el complemento",
  "Connection test failed": "La prueba de conexión falló",
  "United States": "Estados Unidos",
  "Canada": "Canadá",
  "United Kingdom": "Reino Unido",
  "Australia": "Australia",
  "Germany": "Alemania",
  "France": "Francia",
  "Spain": "España",
  "Italy": "Italia",
  "Netherlands": "Países Bajos",
  "Belgium": "Bélgica",
  "Switzerland": "Suiza",
  "Austria": "Austria",
  "Sweden": "Suecia",
  "Norway": "Noruega",
  "Denmark": "Dinamarca",
  "Finland": "Finlandia",
  "Ireland": "Irlanda",
  "Portugal": "Portugal",
  "Poland": "Polonia",
  "Czech Republic": "Chequia",
  "Japan": "Japón",
  "South Korea": "Corea del Sur",
  "Singapore": "Singapur",
  "India": "India",
  "Brazil": "Brasil",
  "Mexico": "México",
  "Argentina": "Argentina",
  "Chile": "Chile",
  "Colombia": "Colombia",
  "New Zealand": "Nueva Zelanda",
  "South Africa": "Sudáfrica",
  "Israel": "Israel",
  "United Arab Emirates": "Emiratos Árabes Unidos",
  "Saudi Arabia": "Arabia Saudita",
  "Turkey": "Turquía",
  "Greece": "Grecia",
  "Romania": "Rumanía",
  "Hungary": "Hungría",
  "Bulgaria": "Bulgaria",
  "Croatia": "Croacia",
  "Other": "Otro",
  "Get real-time notifications in Slack when tests complete": "Recibe notificaciones en Slack cuando terminen las pruebas",
  "Receive test results and alerts in your Discord server": "Recibe resultados de pruebas y alertas en tu servidor de Discord",
  "One-click bug reports with screenshots, logs, and repro steps": "Reporta errores con capturas, registros y pasos de reproducción con un clic",
  "Slack Webhook URL": "URL del webhook de Slack",
  "Discord Webhook URL": "URL del webhook de Discord",
  "Jira API Token": "Token de API de Jira",
  "Your Jira API token": "Tu token de API de Jira",
  "Please save the integration first before testing": "Guarda la integración antes de probarla",
  "Test issue created successfully!": "¡Incidencia de prueba creada correctamente!",
  "Test notification sent successfully!": "¡Notificación de prueba enviada correctamente!",
  "Failed to send test notification": "No se pudo enviar la notificación de prueba",
  "Integration saved successfully!": "¡Integración guardada correctamente!",
  "Failed to save integration": "No se pudo guardar la integración",
  "Integration deleted successfully": "Integración eliminada correctamente",
  "Failed to delete integration": "No se pudo eliminar la integración",
  "+ Add Project": "+ Agregar proyecto",
  "+ Add Channel": "+ Agregar canal",
  "Connect": "Conectar",
  "Active": "Activa",
  "Paused": "En pausa",
  "Auto-create": "Creación automática",
  "Pause integration": "Pausar integración",
  "Resume integration": "Reanudar integración",
  "Pause": "Pausar",
  "Resume": "Reanudar",
  "Configure": "Configurar",
  "Delete": "Eliminar",
  "Jira Site URL *": "URL del sitio de Jira *",
  "Your Jira Cloud instance URL": "URL de tu instancia de Jira Cloud",
  "Email": "Correo electrónico",
  "Leave empty to keep current email": "Deja vacío para conservar el correo actual",
  "Current:": "Actual:",
  "API Token": "Token de API",
  "Leave empty to keep current token": "Deja vacío para conservar el token actual",
  "✓ API Token is configured. Enter a new token only if you want to update it.": "✓ El token de API está configurado. Ingresa uno nuevo solo si deseas actualizarlo.",
  "How to generate an API token": "Cómo generar un token de API",
  "Project Key *": "Clave del proyecto *",
  "e.g., PROJ, DEV": "Por ejemplo: PROJ, DEV",
  "Issue Type": "Tipo de incidencia",
  "Bug": "Error",
  "Task": "Tarea",
  "Story": "Historia",
  "Epic": "Épica",
  "Automatically create Jira tickets on test failures": "Crear incidencias en Jira automáticamente cuando fallen las pruebas",
  "Leave empty to keep existing webhook URL": "Deja vacío para conservar la URL del webhook actual",
  "✓ Webhook URL is configured. Enter a new URL only if you want to update it.": "✓ La URL del webhook está configurada. Ingresa una nueva solo si deseas actualizarla.",
  "How to get a webhook URL": "Cómo obtener la URL de un webhook",
  "Channel Name (Optional)": "Nombre del canal (opcional)",
  "e.g., general, testing, alerts": "Por ejemplo: general, pruebas, alertas",
  "A friendly name to help you identify this integration": "Un nombre para identificar esta integración",
  "Update Integration": "Actualizar integración",
  "Save Integration": "Guardar integración",
  "Create Test Issue": "Crear incidencia de prueba",
  "Delete Integration": "Eliminar integración",
  "Cancel": "Cancelar",
  "View issue": "Ver incidencia",
  "Are you sure you want to delete the {name} integration? This action cannot be undone.": "¿Seguro que deseas eliminar la integración {name}? Esta acción no se puede deshacer.",
  "Organization:": "Organización:",
  "Enabled by {name} on {date}": "Habilitado por {name} el {date}"
};

export const settingsTranslator = (language) => (text, values = {}) => {
  if (typeof text !== 'string') return text;
  const translated = language === 'es' ? (es[text] ?? text) : text;
  return translated.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
};
